/**
 * Default referral amount (in dollars) shown when userCredits.referralGetAmount
 * is not available. Used for link preview metadata and as fallback in UI.
 *
 * NOTE: Keep in sync with gondola-mobile-app/lib/referral.ts.
 */
export const DEFAULT_REFERRAL_AMOUNT = 50;

/** Gondola Cash referral goal highlighted in referral promotion copy. */
export const REFERRAL_CREDIT_GOAL = 1000;

/** Copy shown to the referred person when they get $0. */
export const INVITEE_MESSAGE_WHEN_ZERO =
  "You're invited. Stack your points and earn cash back on Gondola";

/**
 * Post-signup welcome copy when the code carried no credit — a $0 referral, or a
 * promotion that only attributes the signup (a `promotions` row with amount 0).
 * Distinct from INVITEE_MESSAGE_WHEN_ZERO, which is the *pre*-signup invite pitch.
 */
export const WELCOME_MESSAGE_NO_OFFER =
  "Welcome to Gondola, we're excited to have you onboard!";

/** Copy shown to the referred person when they get a positive amount (use actual value). */
export const getInviteeMessageWithAmount = (amount: number): string =>
  `You're invited. Earn $${amount} after your first booking!`;

/** Copy shown when a promotion grants Gondola Gold status on signup. */
export const INVITEE_MESSAGE_GONDOLA_GOLD =
  "You've been gifted Gondola Gold — 7% cash back on every hotel booking";

/** Cashback tier value that indicates Gondola Gold status. */
export const GONDOLA_GOLD_CASHBACK_TIER = 7;

/** Pick the invitee landing/OG copy based on what the referral code grants. */
export const getInviteeMessage = (
  giveAmount: number,
  grantsCashbackTier?: number | null
): string => {
  if (
    grantsCashbackTier !== null &&
    grantsCashbackTier !== undefined &&
    grantsCashbackTier >= GONDOLA_GOLD_CASHBACK_TIER
  ) {
    return INVITEE_MESSAGE_GONDOLA_GOLD;
  }
  if (giveAmount > 0) {
    return getInviteeMessageWithAmount(giveAmount);
  }
  return INVITEE_MESSAGE_WHEN_ZERO;
};
